import { useState } from 'react'
import axios from 'axios'

export default function useLogoUpload({ url, onComplete }) {
  const [uploading, setUploading] = useState(null)
  const [error, setError] = useState(null)

  const upload = async (file) => {
    setError(null)
    setUploading({ fileName: file.name, percent: 0 })
    try {
      await axios.put(`${url}/${encodeURIComponent(file.name)}`, file, {
        withCredentials: true,
        headers: { 'Content-Type': file.type },
        onUploadProgress: (e) => setUploading({ fileName: file.name, percent: Math.round((e.progress ?? 0) * 100) }),
      })
      await onComplete()
    } catch (err) {
      setError(err.message)
    } finally {
      setUploading(null)
    }
  }

  return { upload, uploading: uploading ?? undefined, error: error ?? undefined }
}
